export default __webpack_public_path__ + "static/media/UploadImgIcon.a51a1d99.svg";